import { z } from 'zod';

import {
  DimensionBaseItemSchema,
  DimensionFormatTypeSchema,
  MetricItemSchema,
  MetricScaleSchema,
} from './common.js';

const PivotTableDimensionSchema = DimensionBaseItemSchema.extend({
  dimensionType: DimensionFormatTypeSchema.optional(),
});

const PivotTableDimensionFilterSchema = z.object({
  id: z.string(),
  value: z.string(),
  dimensionType: DimensionFormatTypeSchema,
  isEqual: z.boolean().optional(),
  isContains: z.boolean().optional(),
  valueType: z.string().optional(),
});

const PivotTableMetricFilterSchema = z.object({
  id: z.string(),
  filter: z.array(z.string()),
});

const PivotTableTimeFilterSchema = z.object({
  since: z.string(),
  to: z.string(),
});

export const PivotTableRequestSchema = z.object({
  companyId: z.string(),
  widgetId: z.string().optional(),
  widgetType: z.string().optional(),
  metrics: z.array(z.string()),
  dimensions: z.array(PivotTableDimensionSchema),
  granularity: MetricScaleSchema,
  dimensionFilters: z.array(PivotTableDimensionFilterSchema).optional(),
  metricFilters: z.array(PivotTableMetricFilterSchema).optional(),
  timeFilter: PivotTableTimeFilterSchema,
});

export const PivotTableComparisonRequestSchema = z.object({
  companyId: z.string(),
  widgetId: z.string().optional(),
  widgetType: z.string().optional(),
  metrics: z.array(z.string()),
  dimensions: z.array(PivotTableDimensionSchema),
  granularity: MetricScaleSchema,
  dimensionFilters: z.array(PivotTableDimensionFilterSchema).optional(),
  metricFilters: z.array(PivotTableMetricFilterSchema).optional(),
  timeFilter1: PivotTableTimeFilterSchema,
  timeFilter2: PivotTableTimeFilterSchema,
});

export const PivotTableRowSchema: z.ZodType<Record<string, unknown>> = z.lazy(
  () =>
    z
      .object({
        id: z.string().optional(),
        name: z.string().optional(),
        type: z.string().optional(),
        subRows: z.array(PivotTableRowSchema).optional(),
      })
      .catchall(z.unknown()),
);

export const PivotTableResponseSchema = PivotTableRowSchema;

export const PivotMetricsResponseSchema = z.array(MetricItemSchema);

export const PivotTableExportRequestSchema = z.object({
  widgetId: z.string().optional(),
  widgetType: z.string(),
  metrics: z.array(z.string()),
  dimensions: z.array(PivotTableDimensionSchema),
  granularity: MetricScaleSchema,
  dimensionFilters: z.array(PivotTableDimensionFilterSchema).optional(),
  metricFilters: z.array(PivotTableMetricFilterSchema).optional(),
  dateFrom: z.string(),
  dateTo: z.string(),
});

export const PivotTableExportResponseSchema = z.object({
  data: z.object({
    message: z.string().nullable().optional(),
    items: z.array(z.object({ id: z.string(), taskStatus: z.string() })),
  }),
});
